import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useProductSwiperData, handleStoreClick } from "../hooks/Shopify";

const ShopifySidebar = () => {
    const qry = useProductSwiperData();
    if (
      !Array.isArray(qry.product.nodes) ||
      qry.product.nodes[0].title === "placeholder"
    ) return null
    else {
      const toShow = qry?.product?.nodes.slice(0,6)
      const storeLogo = qry.wp.store.logo.gatsbyImage;
      const storeUrl = qry.wp.store.url
      return (
        <aside 
      className="shopify bg-white text-black overflow-hidden pb-4 sm:pb-6 md:pb-8 lg:pb-10 flex flex-col w-full lg:max-w-[350px] max-h-[1200px] h-full px-4 sm:px-6 md:px-8 lg:px-10 overflow-y-auto mx-auto md:mx-0 md:ml-auto justify-center"
      style={{
        position:'sticky',
        alignSelf:'start',
        top:'12rem',
      }}
    >
      <div className="store-branding mb-4 lg:mb-0 flex justify-center">
        <a href={storeUrl} onClick={handleStoreClick}>
          <GatsbyImage
            image={storeLogo}
            alt="Store logo"
            objectFit="contain"
            layout="fullWidth"
            loading="lazy"
            className="mx-auto h-20 sm:h-24 lg:h-48 lg:w-60"
          />
        </a>
      </div>
      <div className="product-list flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 grid grid-cols-1 gap-4 mx-auto">
                {toShow && toShow.map((product, index) => { 
                  const image = getImage(product.image.childImageSharp.gatsbyImageData)
                  return (
                    <div key={index} className="flex flex-col justify-between py-2 bg-white text-green-900">
                        <a 
                          href={`${storeUrl}/products/${product.handle}`} 
                          className="group flex flex-col flex-nowrap justify-center"
                          onClick={handleStoreClick}
                        >
                            <GatsbyImage
                                image={image}
                                alt={product.title}
                                objectFit="contain"
                                layout="fullWidth"
                                className="transition-all duration-500 group-hover:scale-105"
                            />
                            <div className="p-2">
                                <h3 className="font-semibold text-center text-xs sm:text-sm md:text-base mb-1 transition-all duration-500 group-hover:text-yellow-500">{product.title}</h3>
                            </div>
                        </a>
                    </div>
                  )
                })}
            </div>
        </aside>
      );
    }
};

export default ShopifySidebar;
